<div class="wrapper wrapper-content mtv-parcels-page row">
    <div class="ibox mainPartPage">
        <div class="ibox-content">
            <div class="row">
                <div class="col-sm-7">
                    <filter [tabHeading]="'Classifieds'" [buildings]="classifiedsMccService.buildings"></filter>
                </div>

                <classifieds-mcc-filter></classifieds-mcc-filter>

                <div class="col-sm-3">
                    <button type="button" class="btn btn-w-m btn-primary pull-right"
                            (click)="classifiedsMccService.isClassifiedsModalShow = true">
                        <i class="fa fa-plus-circle"></i> New Classified
                    </button>
                </div>

            </div>
            <tabs-wrapper>
                <tab-item [tabId]="'allClassifiedsMcc'" [ngClass]="{'sk-loading': classifiedsMccService.spinnerShow}">
                    <classifieds-mcc-list></classifieds-mcc-list>
                </tab-item>
                <pagination *ngIf="classifiedsMccService.data.allClassifiedsMcc.total && urlService.queryParams['page']"
                            [total]="classifiedsMccService.data['allClassifiedsMcc'].total"></pagination>
                <spinner [spinnerShow]="classifiedsMccService.spinnerShow"></spinner>
            </tabs-wrapper>
        </div>
    </div>
</div>

<classifieds-mcc-modal *ngIf="classifiedsMccService.isClassifiedsModalShow"></classifieds-mcc-modal>



// WEBPACK FOOTER //
// /app/src/app/views/classifieds-mcc/classifieds-mcc.component.html